import { connect } from 'react-redux';

import * as univariateSummariesSelectors from 'selectors/univariateSummaries';
import { getSelectedStats } from 'store';


import CategoricalSummaryComponent from './Component';

const mapStateToProps = state => {
  const selectedColumns = getSelectedStats(state);

  return {
    summary: univariateSummariesSelectors.getVisibleCategoricalSummary(state),
    selectedColumns
  };
};

export default connect(mapStateToProps)(
  CategoricalSummaryComponent
);
